import { useState, useLayoutEffect, SyntheticEvent } from 'react';
import { LeadGenWidget } from './LeadGenWidget.tsx';
import { Svg } from '../common/Svg.js';
import Email from '../../../images/project/lead-gen-email-icon.svg';

interface MinimizedLeadGenWidgetProps {
	removeLeadGenWidget: () => void;
}

// TODO Restyle this - make it unobtrusive but floating (like, position:absolute or whatever).
export const MinimizedLeadGenWidget = ({ removeLeadGenWidget }: MinimizedLeadGenWidgetProps) => {
    const [open, setOpen] = useState(false);
    const [bottomOffset, setBottomOffset] = useState(0);

    // used to set bottom positioning on widget to account for variable height give bar on mobile
    useLayoutEffect(() => {
        const donationBox = document.querySelector('.js-mobile-donation-box') as HTMLElement;
        const defaultMargin = 0;
        const calculateBottomOffset = () => {
            if (donationBox) {
                setBottomOffset(donationBox.offsetHeight + defaultMargin);
            } else {
                setBottomOffset(defaultMargin);
            }
        };

        calculateBottomOffset();
        window.addEventListener('resize', calculateBottomOffset);
        const observer = new ResizeObserver(calculateBottomOffset);

        if (donationBox) {
            observer.observe(donationBox);
        }

        return () => {
            window.removeEventListener('resize', calculateBottomOffset);
            observer.disconnect();
        };
    }, []);

    const openHandler = (e: SyntheticEvent) => {
        e.preventDefault();
        setOpen(true);
    };

    const hideHandler = (e: SyntheticEvent) => {
        e.preventDefault();
        removeLeadGenWidget();
    };

    const closeHandler = () => {
        setOpen(false);
    };

    let form = null;
    if (open) {
        form = <LeadGenWidget minimizedLeadGenEnabled={true} manualCloseHandler={closeHandler} successfulSubmitHandler={removeLeadGenWidget} />;
    }

    return (
        <div>
            {form}
            <div className="minimized" style={{ bottom: `${bottomOffset}px` }}>
                <button className="circular-close" onClick={hideHandler} aria-label="Dismiss">
                    <Svg icon={'delete'} additionalClasses='is-button' attributes={{ role: 'presentation' }}/>
                </button>
                <div className="blorbo-container">
                    <svg>
                        <path className="blorbo"
								  d="M2.4,138.9c-8.2,24.8,11.3,53.5,43.5,64.2l165.7,68.4c32.2,10.7,168.2,30.6,176.4,5.8l-1.9-194c1.9-35-11.3-53.5-43.5-64.2C308.9,7.9,274.9,2,242.3.8c-56-2-87.6,43.2-61.5,86.6l-4.5-5.2c-32.1-37.9-96-46.2-127.7-16.1C27.5,86.2,11.7,110.7,2.4,138.9h0Z"/>
                    </svg>
                </div>
                <div className="email-icon">
                    <Email/>
                </div>
                <button className="lead-gen-subscribe" onClick={openHandler}>
                    Sign up today
                    <p>and we'll send you a $25 promo code</p>
                </button>
            </div>

            {/* <button onClick={hideHandler}>Click here to not receive emails :(</button> */}
        </div>
    );
};
